import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { tenantSetting } from '@env/environment';

@Injectable({
    providedIn: 'root',
})
export class Utils {
    getPermissions(permissionName: string): boolean {
        const allPermissions = localStorage.getItem('permissions')?.split(',');
        if (allPermissions && allPermissions.some((permission) => permission === permissionName)) {
            return true;
        } else {
            return false;
        }
    }

    getTenantKeyByName(): string {
        const tenantKey = localStorage.getItem('tenantKey') || '';
        const { key = '' } = tenantSetting.find((item) => tenantKey.startsWith(item.name)) || {};
        return key;
    }

    /**
     * Recursively retrieves route data from the current activated route and its child routes.
     *
     * @param {ActivatedRoute} route
     *
     * @returns {any} - An object containing all the collected route data from the current and
     * child routes.
     *
     * @example
     * const routeData = this.getRouteData(this.activatedRoute);
     * console.log(routeData); // { title: 'Home', description: 'Welcome to the homepage' }
     */
    getRouteData(route: ActivatedRoute): any {
        let data = route.snapshot.data;
        while (route.firstChild) {
            route = route.firstChild;
            data = { ...data, ...route.snapshot.data };
        }
        return data;
    }
}
